const bar = document.querySelector( '.announcementBar' );
const closeBar = document.querySelector( '.announcementBar-close' );

function showBar() {
	if ( sessionStorage.getItem( 'bar' ) !== 'hidden' ) {
		bar.setAttribute( 'style', 'display:flex' );
	}
}

function hideBar() {
	sessionStorage.setItem( 'bar', 'hidden' );
	bar.setAttribute( 'style', 'display:none' );
}

function initEvents() {
	closeBar.addEventListener( 'click', hideBar );
}

function init() {
	if ( !bar ) {
		return;
	}

	showBar();
	initEvents();
}

export default {
	init,
};
